export default __webpack_public_path__ + "static/media/giglinked_symbol-red.0095a9c9.png";